module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/tablet@2x-2bcc12cae4b3b89937d059745aaa66d9.webp";